
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm1.134 16.17v8.704h-3.601V16.17h-1.8v-3h1.8v-1.801c0-2.447 1.016-3.902 3.903-3.902h2.403v3h-1.502c-1.124 0-1.198.419-1.198 1.201l-.005 1.502h2.722l-.319 3h-2.403z","fill":"currentColor"}})])
          )
        }
      }
    